import { useQuery } from '@tanstack/react-query';
import { leadsService } from '../services/leads.service';

export function useKanban(productId: number) {
  return useQuery({
    queryKey: ['leads', 'kanban', productId],
    queryFn: () => leadsService.getKanban(productId),
    enabled: !!productId,
  });
}

export function useFollowUps(productId?: number) {
  return useQuery({
    queryKey: ['leads', 'follow-ups', productId],
    queryFn: () => leadsService.getFollowUps(productId),
  });
}

export function useLead(id: number | null) {
  return useQuery({
    queryKey: ['leads', id],
    queryFn: () => leadsService.getById(id as number),
    enabled: !!id,
  });
}

export function useLeadNotes(id: number) {
  return useQuery({
    queryKey: ['leads', id, 'notes'],
    queryFn: () => leadsService.getNotes(id),
    enabled: !!id,
  });
}
